import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { DataProvider } from "./context/DataContext";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { PageDataProvider } from "./context/PageDataContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <DataProvider>
        <PageDataProvider>
          <App />
        </PageDataProvider>
      </DataProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
